import request from 'api/requestUtils'

export interface LeLiveRegistrationPayload {
  ticketQuantity: number
  eventDay: 'saturday' | 'sunday'
  marketingOptIn: boolean
}

export type ApiEventDay = 'DAY_ONE' | 'DAY_TWO'

export interface LeLiveRegistration {
  id: string
  userId: string
  email: string
  firstName: string
  lastName: string | null
  eventDay: ApiEventDay
  ticketQuantity: number
  marketingOptIn: boolean
  confirmationCode: string
}

export interface LeLiveRegistrationListItem extends LeLiveRegistration {
  createdAt: string
}

interface ApiResponse<T> {
  statusCode: number
  result: T
}

const EVENT_DAY_MAP: Record<LeLiveRegistrationPayload['eventDay'], ApiEventDay> = {
  saturday: 'DAY_ONE',
  sunday: 'DAY_TWO',
}

export async function registerForLeLive(payload: LeLiveRegistrationPayload): Promise<LeLiveRegistration> {
  const response = await request.post<ApiResponse<LeLiveRegistration>, {
    eventDay: ApiEventDay
    ticketQuantity: number
    marketingOptIn: boolean
  }>(
    '/api/occasions/v1/le-live/registrations',
    {
      eventDay: EVENT_DAY_MAP[payload.eventDay],
      ticketQuantity: payload.ticketQuantity,
      marketingOptIn: payload.marketingOptIn,
    },
    { credentials: 'include' },
  )
  return response.result
}

export async function updateLeLiveRegistration(payload: LeLiveRegistrationPayload): Promise<LeLiveRegistration> {
  const response = await request.put<ApiResponse<LeLiveRegistration>, {
    eventDay: ApiEventDay
    ticketQuantity: number
    marketingOptIn: boolean
  }>(
    '/api/occasions/v1/le-live/registrations/me',
    {
      eventDay: EVENT_DAY_MAP[payload.eventDay],
      ticketQuantity: payload.ticketQuantity,
      marketingOptIn: payload.marketingOptIn,
    },
    { credentials: 'include' },
  )
  return response.result
}

export async function getMyRegistrations(): Promise<Array<LeLiveRegistrationListItem>> {
  const response = await request.get<ApiResponse<Array<LeLiveRegistrationListItem>>>(
    '/api/occasions/v1/le-live/registrations/me',
    { credentials: 'include' },
  )
  return response.result
}
